// How a typed name is tidied before it is compared or stored: surrounding spaces dropped and runs
// of spaces collapsed to one, so "Corner  Shop " and "Corner Shop" are the same name. Shared by
// the app and the server, so what a form shows is what the store keeps.

export const cleanName = (name: string) => name.trim().replace(/\s+/g, " ");

/**
 * What two names are compared by: tidied, and ignoring case — the same rule the store applies when
 * it looks a category or payee up, so "dining" typed anywhere finds the "Dining" already there.
 */
export const nameKey = (name: string) => cleanName(name).toLowerCase();

/** The names not already among `existing`, each once, in the spelling first given. */
export function newNames(existing: readonly string[], candidates: readonly string[]): string[] {
  const seen = new Set(existing.map(nameKey));
  return candidates.filter((name) => {
    const key = nameKey(name);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

/** The existing option a name refers to, spelled as it is stored, or undefined when there is none. */
export function matchingName(options: readonly string[], name: unknown): string | undefined {
  if (typeof name !== "string" || !name.trim()) return undefined;
  const key = nameKey(name);
  return options.find((option) => nameKey(option) === key);
}
